export default __webpack_public_path__ + "static/media/spec-typography-desktop.1753b5ae.png";